import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./initialState.js";

export const queriesSelector = (name, path) =>
  createSelector(
    (state) => state.queries,
    (queries) => {
      return { ...initialState[name], ...queries[path] };
    },
  );
